import './cookie_banner_component.scss'
import CookiesEuBanner from 'cookies-eu-banner'
import { Controller } from 'stimulus'
import { inIframe } from 'relation-map/utils'

export default class extends Controller {
  initialize = (): void => {
    if (inIframe()) return
    new CookiesEuBanner(() => { // eslint-disable-line
    }, true)
  }
}
